export default {
  computed: {
    $socials() {
      return [
        {
          id: 100,
          name: "Instagram",
          type: "insta",
          prefix: "https://instagram.com/{profileName}",
          svg: "/assets/svg/social/insta.svg",
          isAvail: false
        },
        {
          id: 101,
          name: "Facebook",
          type: "fb",
          prefix: "https://facebook.com/{profileName}",
          svg: "/assets/svg/social/fb.svg",
          isAvail: false
        },
        {
          id: 102,
          name: "Twitter",
          type: "twitter",
          prefix: "https://twitter.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 1,
          name: "About Me",
          type: "aboutme",
          prefix: "https://about.me/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 2,
          name: "Quora",
          type: "quora",
          prefix: "https://www.quora.com/profile/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 3,
          name: "Skill Share",
          type: "skillshare",
          prefix: "https://www.skillshare.com/en/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 4,
          name: "Visual.ly",
          type: "visually",
          prefix: "https://visual.ly/users/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 5,
          name: "Issuu",
          type: "issuu",
          prefix: "https://issuu.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 6,
          name: "Edocr",
          type: "edocr",
          prefix: "https://www.edocr.com/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 7,
          name: "Knoji",
          type: "knoji",
          prefix: "https://knoji.com/meet/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 8,
          name: "HubPages",
          type: "hubpages",
          prefix: "https://hubpages.com/@{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 9,
          name: "SlideShare",
          type: "slideshare",
          prefix: "https://www.slideshare.net/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 10,
          name: "Disqus",
          type: "disqus",
          prefix: "https://disqus.com/by/{profileName}/about/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 11,
          name: "Kickstarter",
          type: "kickstarter",
          prefix: "https://www.kickstarter.com/profile/{profileName}/about",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 12,
          name: "500px",
          type: "500px",
          prefix: "https://500px.com/p/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 13,
          name: "Last.fm",
          type: "lastfm",
          prefix: "https://www.last.fm/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 14,
          name: "Livejournal",
          type: "livejournal",
          prefix: "https://{profileName}.livejournal.com/profile",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 15,
          name: "Tumblr",
          type: "tumblr",
          prefix: "https://www.tumblr.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 14,
          name: "dummy",
          type: "dummy please remove it",
          prefix: "https://{profileName}.livejournal.com/profile/{profileId}",
          svg: ""
        },
        {
          id: 16,
          name: "Scribd",
          type: "scribd",
          prefix: "https://www.scribd.com/user/{userId}/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 17,
          name: "Goodreads",
          type: "goodreads",
          prefix: "https://www.goodreads.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 18,
          name: "Gravatar",
          type: "gravatar",
          prefix: "https://en.gravatar.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 19,
          name: "Reddit",
          type: "reddit",
          prefix: "https://www.reddit.com/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 20,
          name: "Scoop.it!",
          type: "scoop",
          prefix: "https://www.scoop.it/u/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 21,
          name: "Know Your Meme",
          type: "knowyourmeme",
          prefix: "https://knowyourmeme.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 22,
          name: "Alltrails",
          type: "alltrails",
          prefix: "https://www.alltrails.com/members/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 23,
          name: "Magcloud",
          type: "magcloud",
          prefix: "https://www.magcloud.com/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 24,
          name: "TED",
          type: "ted",
          prefix: "https://www.ted.com/profiles/{userId}/about",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 25,
          name: "Paper.li",
          type: "paperli",
          prefix: "https://paper.li/~/publisher/{userId}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 26,
          name: "Independent.academia",
          type: "independentacademia",
          prefix: "https://independent.academia.edu/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 27,
          name: "Recode",
          type: "recode",
          prefix: "https://www.recode.net/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 28,
          name: "Republic",
          type: "republic",
          prefix: "https://republic.com/@{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 29,
          name: "Data.world",
          type: "dataworld",
          prefix: "https://data.world/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 30,
          name: "Blurb",
          type: "blurb",
          prefix: "https://www.blurb.com/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 31,
          name: "Theverge",
          type: "theverge",
          prefix: "https://www.theverge.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 32,
          name: "Kiva",
          type: "kiva",
          prefix: "https://www.kiva.org/lender/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 33,
          name: "Hackster",
          type: "hackster",
          prefix: "https://www.hackster.io/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 34,
          name: "CreativeLive",
          type: "creativelive",
          prefix: "https://www.creativelive.com/student/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 35,
          name: "CreativeLive",
          type: "creativelive",
          prefix: "https://creator.wonderhowto.com/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 36,
          name: "Bandcamp",
          type: "bandcamp",
          prefix: "https://bandcamp.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 37,
          name: "Coderwall",
          type: "coderwall",
          prefix: "https://coderwall.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 38,
          name: "Ttlink",
          type: "ttlink",
          prefix: "http://ttlink.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 39,
          name: "Authorstream",
          type: "authorstream",
          prefix: "https://www.authorstream.com/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 40,
          name: "Gitlab",
          type: "gitlab",
          prefix: "https://gitlab.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 41,
          name: "Deviantart",
          type: "deviantart",
          prefix: "https://www.deviantart.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 42,
          name: "Seekingalpha",
          type: "seekingalpha",
          prefix: "https://seekingalpha.com/user/{userId}}/comments",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 43,
          name: "icheckmovies",
          type: "icheckmovies",
          prefix: "https://www.icheckmovies.com/profiles/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 44,
          name: "gfycat",
          type: "gfycat",
          prefix: "https://gfycat.com/@{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 45,
          name: "Openlearning",
          type: "openlearning",
          prefix: "https://www.openlearning.com/u/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 46,
          name: "Hometalk",
          type: "hometalk",
          prefix: "https://www.hometalk.com/member/{userId}/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 47,
          name: "Ranker",
          type: "ranker",
          prefix: "https://www.ranker.com/writer/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 48,
          name: "Sbnation",
          type: "sbnation",
          prefix: "https://www.sbnation.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 49,
          name: "Aeriagames",
          type: "aeriagames",
          prefix: "https://www.aeriagames.com/user/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 50,
          name: "Sketchfab",
          type: "sketchfab",
          prefix: "https://sketchfab.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 51,
          name: "Devpost",
          type: "devpost",
          prefix: "https://devpost.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 52,
          name: "Flipsnack",
          type: "flipsnack",
          prefix: "https://www.flipsnack.com/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 53,
          name: "list.ly",
          type: "listly",
          prefix: "https://list.ly/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 54,
          name: "Programmableweb",
          type: "programmableweb",
          prefix: "https://www.programmableweb.com/profile/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 55,
          name: "Crowdfunder",
          type: "crowdfunder",
          prefix: "https://www.crowdfunder.co.uk/user/{profileName}/profile",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 56,
          name: "Letterboxd",
          type: "letterboxd",
          prefix: "https://letterboxd.com/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 57,
          name: "Eater",
          type: "eater",
          prefix: "https://www.eater.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 58,
          name: "Buzzsprout",
          type: "buzzsprout",
          prefix: "https://www.buzzsprout.com/{userId}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 59,
          name: "Slides",
          type: "slides",
          prefix: "https://slides.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 60,
          name: "Polygon",
          type: "polygon",
          prefix: "https://www.polygon.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 61,
          name: "Mapleprimes",
          type: "mapleprimes",
          prefix: "https://www.mapleprimes.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 62,
          name: "Codementor",
          type: "codementor",
          prefix: "https://www.codementor.io/@{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 63,
          name: "Atlas.Dustforce",
          type: "dustforce",
          prefix: "http://atlas.dustforce.com/user/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 64,
          name: "Trello",
          type: "trello",
          prefix: "https://trello.com/u/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 65,
          name: "Mixcloud",
          type: "mixcloud",
          prefix: "https://www.mixcloud.com/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 66,
          name: "Bloglovin",
          type: "bloglovin",
          prefix: "https://www.bloglovin.com/@{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 67,
          name: "Tagged",
          type: "tagged",
          prefix: "https://secure.tagged.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 68,
          name: "Cookpad",
          type: "cookpad",
          prefix: "https://cookpad.com/in/users/{userId}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 69,
          name: "Buzzfeed",
          type: "buzzfeed",
          prefix: "https://www.buzzfeed.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 70,
          name: "Hackerrank",
          type: "hackerrank",
          prefix: "https://www.hackerrank.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 71,
          name: "Instructables",
          type: "instructables",
          prefix: "https://www.instructables.com/member/{profileName}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 72,
          name: "Patreon",
          type: "patreon",
          prefix: "https://www.patreon.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 73,
          name: "Ultimate Guitar",
          type: "ultimate-guitar",
          prefix: "https://www.ultimate-guitar.com/u/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 74,
          name: "Growthhackers",
          type: "growthhackers",
          prefix: "https://community.growthhackers.com/members/{userId}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 75,
          name: "Angel.co",
          type: "angel",
          prefix: "https://angel.co/u/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 76,
          name: "iFixit",
          type: "ifixit",
          prefix: "https://www.ifixit.com/User/{userId}/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 77,
          name: "Medium",
          type: "medium",
          prefix: "https://medium.com/@{profileName}_/about",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 78,
          name: "Racked",
          type: "racked",
          prefix: "https://www.racked.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 79,
          name: "MySpace",
          type: "myspace",
          prefix: "https://myspace.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 80,
          name: "Vox",
          type: "vox",
          prefix: "https://www.vox.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 81,
          name: "Strava",
          type: "strava",
          prefix: "https://www.strava.com/athletes/{userId}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 82,
          name: "4Shared",
          type: "4shared",
          prefix: "https://www.4shared.com/u/{userId}/{profileName}.html",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 83,
          name: "SoundCloud",
          type: "soundcloud",
          prefix: "https://soundcloud.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 84,
          name: "MeetUp",
          type: "meetup",
          prefix: "https://www.meetup.com/members/{userId}/",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 85,
          name: "Diigo",
          type: "diigo",
          prefix: "https://www.diigo.com/profile/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 86,
          name: "Atlasobscura",
          type: "atlasobscura",
          prefix: "https://www.atlasobscura.com/users/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 87,
          name: "Audiomack",
          type: "audiomack",
          prefix: "https://audiomack.com/{profileName}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },

        {
          id: 88,
          name: "Minds",
          type: "minds",
          prefix: "https://www.minds.com/{profileName}/about",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        },
        {
          id: 89,
          name: "Orcid",
          type: "orcid",
          prefix: "https://orcid.org/{userId}",
          svg: "/assets/svg/social/twitter.svg",
          isAvail: false
        }
      ];
    }
  }
};
